import { TemplateRef } from '@angular/core';
import { ProductoCementoVm } from '../../../models/producto-cemento.vm';
import { AdminServerTableCellContext, AdminServerTableColumn } from '../../../shared/table/models/admin-server-table.model';

interface ProductosColumnsTemplates {
  priceCellTemplate: TemplateRef<AdminServerTableCellContext<ProductoCementoVm>>;
  actionsCellTemplate: TemplateRef<AdminServerTableCellContext<ProductoCementoVm>>;
}

export function buildProductosCementoColumns(
  templates: ProductosColumnsTemplates,
): AdminServerTableColumn<ProductoCementoVm>[] {
  return [
    {
      id: 'nombreComuna',
      header: 'Comuna',
      sortable: true,
      sortKey: 'nombre_comuna',
      headerClass: 'admin-col-sticky-left admin-col-truncate-xs admin-col-width-xs admin-col-nowrap',
      cellClass: 'admin-col-sticky-left admin-col-truncate-xs admin-col-width-xs admin-col-nowrap',
      value: (row) => row.nombreComuna,
      title: (row) => row.nombreComuna,
    },
    {
      id: 'producto',
      header: 'Producto',
      sortable: true,
      sortKey: 'producto',
      value: (row) => row.producto,
      title: (row) => row.producto,
    },
    {
      id: 'nombrePublicacion',
      header: 'Nombre publicación',
      sortable: true,
      sortKey: 'nombre_publicacion',
      headerClass: 'admin-col-truncate-lg',
      cellClass: 'admin-col-truncate-lg',
      value: (row) => row.nombrePublicacion,
      title: (row) => row.nombrePublicacion,
    },
    {
      id: 'multiplo',
      header: 'Mult.',
      sortable: true,
      sortKey: 'multiplo',
      headerClass: 'admin-col-tight-multiplo',
      cellClass: 'admin-col-num admin-col-nowrap admin-col-tight-multiplo',
      value: (row) => row.multiplo,
    },
    {
      id: 'unidad',
      header: 'Und.',
      sortable: true,
      sortKey: 'unidad',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.unidad,
    },
    {
      id: 'incoterms',
      header: 'Incot.',
      sortable: true,
      sortKey: 'incoterms',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.incoterms,
    },
    {
      id: 'skuPos10',
      header: 'SKU 10',
      sortable: true,
      sortKey: 'sku_pos10',
      cellClass: 'admin-col-nowrap admin-col-tight-sku10',
      value: (row) => row.skuPos10 || '—',
      title: (row) => row.skuPos10 || '',
    },
    {
      id: 'skuPos20',
      header: 'SKU 20',
      sortable: true,
      sortKey: 'sku_pos20',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.skuPos20 || '—',
    },
    {
      id: 'skuPos30',
      header: 'SKU 30',
      sortable: true,
      sortKey: 'sku_pos30',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.skuPos30 || '—',
    },
    {
      id: 'precioBruto',
      header: 'Precio',
      sortable: true,
      sortKey: 'precio_bruto',
      cellClass: 'admin-col-num admin-col-nowrap',
      cellTemplate: templates.priceCellTemplate,
    },
    {
      id: 'tipoCamion',
      header: 'Camión',
      sortable: true,
      sortKey: 'tipo_camion',
      cellClass: 'admin-col-nowrap',
      value: (row) => row.tipoCamion,
    },
    {
      id: 'activo',
      header: 'Activo',
      sortable: true,
      sortKey: 'activo',
      cellClass: 'admin-col-center admin-col-nowrap',
      value: (row) => (row.activo ? 'Sí' : 'No'),
    },
    {
      id: 'acciones',
      header: 'Acciones',
      sortable: false,
      headerClass: 'admin-col-actions',
      cellClass: 'admin-col-actions',
      cellTemplate: templates.actionsCellTemplate,
      title: () => '',
    },
  ];
}
